import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import classes from '../../../pipeline.module.scss';
import Api from '../../../../../../../api/api';
import Table from '../../../../../../_common/Tables/Table';
import Chip from '../../../../../../_common/Chip/Chip';
import StatusField from '../../../../../../_common/StatusField/StatusField';
import { Card } from '../../PipelineComponents';
import { formattedDate, formattedDateTime } from '../../../pipelineHelpers';

const tableHeader = [
  { name: 'Member', path: 'name' },
  {
    name: 'Source',
    path: 'source',
    render: (d) => (d.source
      ? (
        <div className={classes.chip_wrapper}>
          <Chip text={d.source} gray />
        </div>
      )
      : '-'),
  },
  { name: 'First contact', path: 'firstContactAt' },
  { name: 'Follow-up', path: 'followUpDate' },
  { name: 'Owner', path: 'owner' },
  {
    name: 'Status',
    path: 'status',
    render: (d) => (d.status ? <StatusField status={d.status} /> : '-'),
  },
];

const IntakeLogCard = ({ params }) => {
  const navigate = useNavigate();

  const firstLoad = useRef(true);

  const [leadsData, setLeadsData] = useState([]);
  const [loading, loadingToggle] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        loadingToggle(true);

        const { data } = await Api.getLeads(params);

        setLeadsData((data?.data?.response || []).map((d) => ({
          ...d,
          id: d.PatientId || d.Patient?.id,
          name: [d.Patient?.firstName, d.Patient?.lastName].filter(Boolean).join(' '),
          firstContactAt: formattedDateTime(d.firstContactAt),
          followUpDate: formattedDate(d.followUpDate),
          owner: d.AssignedUser?.name,
        })));

        loadingToggle(false);
        firstLoad.current = false;
      } catch (e) {
        console.warn(e);
      }
    })();
  }, [params]);

  return (
    <Card
      title="Leads & intake log"
      caption="Members who expressed interest but are not yet filling with SP"
      loading={loading}
      firstLoad={firstLoad.current}
      isEmpty={!leadsData.length}
    >
      <div className={`${classes.pipeline_table} ${classes.bordered}`}>
        <Table
          header={tableHeader}
          data={leadsData}
          className={classes.clickable_row}
          onClick={(patientId) => navigate(`/patients/${patientId}`)}
        />
      </div>

      <p className={classes.note}>
        <b>Answer:</b>
        {' '}
        the daily tracker becomes a
        {' '}
        <b>source</b>
        {' '}
        value on the lead - imported daily rather than worked from a separate spreadsheet. One intake
        list, one owner per lead, one conversion number. A lead that converts and then stalls moves into
        the pipeline in section 03; the two are linked by member.
      </p>
    </Card>
  );
};

IntakeLogCard.propTypes = {
  params: PropTypes.object.isRequired,
};

export default IntakeLogCard;
